import { HttpClient } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { Observable } from 'rxjs';
import { APP_CONFIG } from '../app-config.token';
import { AppConfig } from '../app-config';
import { WorkerFileVerificationDetailsDto } from '../models/dtos/worker-file-verification-details-dto';

@Injectable({
  providedIn: 'root',
})
export class WorkerFileService {
  private http = inject(HttpClient);
  private config = inject<AppConfig>(APP_CONFIG);

  private readonly API_URL = this.config.resourceApiURI;

  getWorkerFileVerificationDetails(workerFileId: number): Observable<WorkerFileVerificationDetailsDto> {
    const url = `${this.API_URL}/admin/workerFiles/${workerFileId}`;
    return this.http.get<WorkerFileVerificationDetailsDto>(url);
  }

  approveWorkerFile(workerFileId: number, institutionId: number): Observable<void> {
    const url = `${this.API_URL}/admin/workerFiles/${workerFileId}/approve`;
    return this.http.post<void>(url, { InstitutionId: institutionId });
  }

  rejectWorkerFile(workerFileId: number, reason: string): Observable<void> {
    const url = `${this.API_URL}/admin/workerFiles/${workerFileId}/reject`;
    return this.http.post<void>(url, { Reason: reason });
  }
}
